import { FormBuilder, FormGroup, Validators } from '@angular/forms';


export function createFirstFormGroup(formBuilder: FormBuilder, identifier: string): FormGroup {
  return formBuilder.group({
    nTransporte: ["", Validators.required],
    nTransportista: ["", { disabled: identifier ? identifier.startsWith('45') : false }, Validators.required],
	  albaran: [""],
	  pesoAlbaran: [""],
    dniConductor: [
      "",
      [
        Validators.required,
        //Validators.pattern("^([a-z]|[A-Z])*([0-9]{5,})([a-z]|[A-Z])*$"),
        //Validators.pattern("^([a-z]|[A-Z])*([0-9]{5,})([a-z]|[A-Z])*$|^[0-9]{13}$"),
        Validators.pattern('^(?=(?:.*\\d){5,})[a-zA-Z0-9]+$|^\\d{13}$'), // ahora acepta tambien estos dos formatos: 44006Q9JE y 969555444B99 (Holandes)
        Validators.maxLength(13),
      ],
    ],
    nombreConductor: ["", [Validators.required, Validators.maxLength(20)]],
    movilConductor: ["", [Validators.required, Validators.maxLength(14), Validators.pattern("^[0-9]*$")]],
    frontPlate: ["", Validators.required],
    rearPlate: ["", Validators.required],
    maxWeightAllow: [false],
  });
}

export function createSlotsFormGroup(formBuilder: FormBuilder): FormGroup {
  return formBuilder.group({
    slotDate: ["", Validators.required],
    slot: ["", Validators.required],
    paletUnits: [1],
    });
}
export function createConditionsFormGroup(formBuilder: FormBuilder): FormGroup {
  return formBuilder.group({
    conditionsCtrl: ["", Validators.required],
  });
}

export function createNormasDestinyFormGroup(formBuilder: FormBuilder): FormGroup {
  return formBuilder.group({
    normasDestinyCtrl: ["", Validators.required],
  });
}

export function createFourthFormGroup(formBuilder: FormBuilder): FormGroup {
  return formBuilder.group({
    fourthCtrl: ["", Validators.required],
  });
}

export function createDocumentFormGroup(formBuilder: FormBuilder): FormGroup {
  return formBuilder.group({
    certificateType: ['', Validators.required], // Control para el tipo de certificado
    certificateDedication: [''], // Control para el valor de dedicación
    certificateCleanning: [''], // Control para el valor de lavadero
  });
}



